import React, { useEffect, useState } from 'react';
import { Link } from '@ambiguous/link';
import Icon from '@assets/tsx/icon/pickerIcon';
import gqlMenu from "@assets/gql/menu.gql";
import { useQuery } from '@apollo/client';
import nestChildren from '@assets/ts/nesting';
import client from '../../apollo-client';
import { useI18n } from '@wordpress/react-i18n';
export default function Menu({ menu, type, separator, prefetch }) {
    var _a;
    const { __ } = useI18n();
    const has_prefetch = typeof ((_a = prefetch === null || prefetch === void 0 ? void 0 : prefetch.data) === null || _a === void 0 ? void 0 : _a.menu) === 'object';
    if (has_prefetch) {
        client.writeQuery({
            query: gqlMenu,
            variables: {
                id: menu
            },
            data: prefetch === null || prefetch === void 0 ? void 0 : prefetch.data
        });
    }
    const [items, setItems] = useState([]);
    const { loading, data } = useQuery(gqlMenu, {
        variables: { id: menu },
        client,
    });
    useEffect(() => {
        var _a, _b;
        const flat = (_b = (_a = data === null || data === void 0 ? void 0 : data.menu) === null || _a === void 0 ? void 0 : _a.menuItems) === null || _b === void 0 ? void 0 : _b.nodes;
        if (!flat || flat === null)
            return;
        const nested = nestChildren(flat);
        setItems(nested);
    }, [data]);
    if (loading)
        return (React.createElement(React.Fragment, null,
            __("kraunasi", "ltg-widgets"),
            "..."));
    if (type == 'rows') {
        return (React.createElement("div", { className: `ltg-wp-menu ltg-wp-menu--rows${separator ? ' line-separator' : ''}` }, items && React.createElement(List, { items: items, isOpen: true })));
    }
    return (React.createElement("div", { className: `ltg-wp-menu ltg-wp-menu--cols${separator ? ' line-separator' : ''}` }, Array.isArray(items) && items.map((parent) => {
        var _a;
        return (React.createElement("div", { className: "ltg-wp-menu-col", key: parent.id },
            React.createElement(Link, { className: 'ltg-wp-menu-parent', href: parent.path }, parent.label),
            ((_a = parent.children) === null || _a === void 0 ? void 0 : _a.length) > 0 && React.createElement(List, { items: parent.children, isOpen: true })));
    })));
}
function List({ items, isOpen }) {
    const [open, setOpen] = useState([]);
    const toggleOpen = (id) => {
        const index = open.indexOf(id);
        const oldOpen = [...open];
        if (index > -1) {
            oldOpen.splice(index, 1);
        }
        else {
            oldOpen.push(id);
        }
        setOpen(oldOpen);
    };
    return (React.createElement("div", { className: `ltg-wp-menu-list ${isOpen ? '' : 'd-none'}` }, Array.isArray(items) && items.map(item => {
        var _a, _b, _c;
        const hasChildren = ((_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.length) > 0;
        if (!hasChildren) {
            return (React.createElement("div", { className: 'ltg-wp-menu-item', key: item.id },
                React.createElement(Link, { className: 'ltg-wp-menu-link', href: item.path, target: item.target, rel: item.target == '_blank' ? 'noopener norefferer' : null },
                    ((_b = item === null || item === void 0 ? void 0 : item.icon) === null || _b === void 0 ? void 0 : _b.iconClassName) && (React.createElement("div", { className: "ltg-wp-menu-icon" },
                        React.createElement(Icon, Object.assign({}, item.icon)))),
                    React.createElement("div", { className: "ltg-wp-menu-text" },
                        React.createElement("div", null, item.label),
                        (item === null || item === void 0 ? void 0 : item.description) && React.createElement("div", null, item.description)))));
        }
        return (React.createElement("div", { className: 'ltg-wp-menu-item', key: item.id },
            React.createElement(Link, { className: `ltg-wp-menu-link has-children ${open.indexOf(item.id) ? '' : ' open'}`, href: item.path, onClick: (ev) => {
                    if (open.includes(item.id)) {
                        return;
                    }
                    else {
                        ev.preventDefault();
                        toggleOpen(item.id);
                    }
                } },
                ((_c = item === null || item === void 0 ? void 0 : item.icon) === null || _c === void 0 ? void 0 : _c.iconClassName) && (React.createElement("div", { className: "ltg-wp-menu-icon" },
                    React.createElement(Icon, Object.assign({}, item.icon)))),
                React.createElement("div", { className: "ltg-wp-menu-text" },
                    React.createElement("div", null, item.label),
                    (item === null || item === void 0 ? void 0 : item.description) && React.createElement("div", null, item.description)),
                React.createElement("i", { className: "ltg-wp-menu-arrow fas fa-chevron-down", onClick: (ev) => {
                        ev.stopPropagation();
                        ev.preventDefault();
                        toggleOpen(item.id);
                    } })),
            React.createElement(List, { items: item.children, isOpen: open.indexOf(item.id) > -1 })));
    })));
}
